import React from 'react';

const TimerCart = ({dataTime,theme}) => {
    return (
        <div className={`timer-cart-wrapper ${theme} persian-number d-flex justify-content-center flex-row-reverse`} data-time-offer={dataTime}>
            <div className="day-box">
                <div className="number-time d-flex flex-row-reverse">
                    <div className="index--0 index-time">0</div>
                    <div className="index--1 index-time">0</div>
                </div>
                <div className="status"><span className="text">روز</span></div>
            </div>
            <div className="space-timer">:</div>
            <div className="hour-box">
                <div className="number-time d-flex flex-row-reverse">
                    <div className="index--0 index-time">0</div>
                    <div className="index--1 index-time">0</div>
                </div>
                <div className="status"><span className="text">ساعت</span></div>
            </div>
            <div className="space-timer">:</div>
            <div className="min-box">
                <div className="number-time d-flex flex-row-reverse">
                    <div className="index--0 index-time">0</div>
                    <div className="index--1 index-time">0</div>
                </div>
                <div className="status"><span className="text">دقیقه</span></div>
            </div>
            <div className="space-timer">:</div>
            <div className="sec-box">
                <div className="number-time d-flex flex-row-reverse">
                    <div className="index--0 index-time">0</div>
                    <div className="index--1 index-time">0</div>
                </div>
                <div className="status"><span className="text">ثانیه</span></div>
            </div>
        </div>
    );
};

export default TimerCart;
